import React, { Component } from "react";
import classNames from "classnames";
import { arrayOf, any, bool, func, objectOf, oneOfType, shape, string } from "prop-types";

import FieldLabel from "pages/_components/fields/FieldLabel";
import FieldError from "pages/_components/fields/FieldError";
import withFocus from "pages/_components/withFocus";
import Button from "pages/_components/Button";

class MultiSelectButton extends Component {
    static propTypes = {
        field: shape({
            name: string,
        }).isRequired,
        form: shape({
            errors: objectOf(oneOfType([string, objectOf(string)])),
            touched: objectOf(oneOfType([arrayOf(bool), bool, objectOf(bool)])),
        }).isRequired,
        idForm: string.isRequired,
        inLineControl: bool,
        isFocused: bool,
        options: arrayOf(objectOf(any)).isRequired,
        toggleIsFocused: func,
        searchable: bool,
        placeholder: string,
        label: string,
        disabled: bool,
        value: arrayOf(string),
        onBlur: func,
    };

    static defaultProps = {
        isFocused: false,
        inLineControl: false,
        toggleIsFocused: null,
        searchable: false,
        placeholder: null,
        label: null,
        disabled: false,
        value: [],
        onBlur: () => {},
    };

    handleChange = (clickedOption) => {
        const { field, form, value } = this.props;

        const actualValue = field.value ? field.value : value;

        const clickedOptionIndex = actualValue.indexOf(clickedOption);
        if (clickedOptionIndex >= 0) {
            actualValue.splice(clickedOptionIndex, 1);
            form.setFieldValue(field.name, actualValue);
        } else {
            form.setFieldValue(field.name, [...actualValue, clickedOption]);
        }
    };

    handleBlur = () => {
        const { field, form, toggleIsFocused, onBlur } = this.props;

        form.setFieldTouched(field.name);
        toggleIsFocused();
        onBlur();
    };

    render() {
        const {
            form,
            field,
            isFocused,
            idForm,
            options,
            toggleIsFocused,
            searchable,
            value,
            placeholder,
            label,
            disabled,
        } = this.props;
        const { touched, errors } = form;
        const { name } = field;
        const hasError = touched[field.name] && errors[field.name];
        return (
            <div
                className={classNames("form-group", {
                    "has-error": touched[name] && errors[name],
                })}>
                {label ? (
                    <FieldLabel idField={field.name} labelText={label} />
                ) : (
                    <FieldLabel idField={field.name} labelKey={`${idForm}.${field.name}.label`} />
                )}
                <ul className="nav nav-pills row">
                    {options?.map((option) => (
                        <li key={option.value}>
                            <Button
                                label={option.label}
                                className={classNames("btn btn-outline", {
                                    "is-active": field.value.includes(option.value),
                                    "has-focus": isFocused,
                                })}
                                onClick={() => this.handleChange(option.value)}
                                onBlur={this.handleBlur}
                                onFocus={toggleIsFocused}
                            />
                        </li>
                    ))}
                </ul>

                {hasError && <FieldError error={errors[field.name]} />}
            </div>
        );
    }
}

export default withFocus(MultiSelectButton);
